import CircularProgress from '@zenbusiness/zui/CircularProgress';
import Box from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';
import PropTypes from 'prop-types';

import useBreakpoints from '#client/hooks/useBreakpoints';

import StatementSkeleton from './StatementSkeleton';

import { LoadingContainerStyle, LongLoadingContainerStyle } from './styles';

const BoxStyled = styled(Box)(LoadingContainerStyle);
const LongBoxStyled = styled(Box)(LongLoadingContainerStyle);

const StatementLoading = ({ isLoadingCircle }) => {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  if (!isLoadingCircle) {
    return (
      <BoxStyled aria-label="Loading Skeleton for Statements">
        {[...Array(isDesktop ? 5 : 6)].map((_, index) => (
          <StatementSkeleton
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            role="listitem"
          />
        ))}
      </BoxStyled>
    );
  }
  return (
    <LongBoxStyled aria-label="Loading Circle for Statements">
      <CircularProgress
        color="secondary"
        size={isDesktop ? 80 : 48}
      />
    </LongBoxStyled>
  );
};

export default StatementLoading;

StatementLoading.propTypes = {
  isLoadingCircle: PropTypes.bool.isRequired
};
